import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Uploading Files via API',
  content: `
In addition to loading files via the web interface, you can follow these steps to load files programmatically via API.

## 1. Choose a flat file source node in Pliable

If you already have a flat file source you wish to use, navigate to the source. Otherwise, create a new source with some example data — it's important to upload the same file type you plan to use (CSV/Excel).

Once you have the flat file source, grab the node id from the URL:

\`\`\`
https://app.pliable.co/node/679a86e0362d3d1bd69ee54b
\`\`\`

## 2. Create new upload request

Using the \`NODE_ID\` from the node you selected above and your access token, make a request to the append-file endpoint to obtain an upload URL. You will need to send the filename and mime_type of the file with your POST request.

\`\`\`bash
curl -X POST "https://app.pliable.co/api/v1/node/NODE_ID/append-file" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_ACCESS_TOKEN_HERE" \\
  -d '{
    "filename": "new_data_file.csv",
    "mime_type": "text/csv"
}'
\`\`\`

You will receive a JSON response like the following:

\`\`\`json
{
    "file_id": "666391e811abc1b56a0c9095",
    "upload_url": "https://uploads.us-east-1.pliable.co/tenant/acme_co/source/666391e811abc1b56a0c9095/filename.csv?signature=mYnsf"
}
\`\`\`

## 3. Upload the file

You can now transmit your file by sending a PUT web request to the \`upload_url\`. Pliable will begin processing the data once the file is uploaded.

\`\`\`bash
curl -X PUT "YOUR_UPLOAD_URL" \\
  -H "Content-Type: text/csv" \\
  --data-binary @new_data_file.csv
\`\`\`

Repeat step 2 for subsequent files.
`,
};

export default doc;
